export const ls = {
  set(key, val) {
    if (typeof val === 'object') {
      try {
          window.localStorage[key] = JSON.stringify(val);
      }catch(e) {
          window.localStorage[key] = "";
      }
    } else {
      window.localStorage[key] = val;
    }
  },
  getStr(key) {
    return window.localStorage[key] || '';
  },
  getJSONObj(key) {
    if (!window.localStorage[key]) return null;
    try {
        return JSON.parse(window.localStorage[key]);
    }
    catch(e) {
      return {}
    }
  },
};

export const ss = {
  set(key, val) {
    if (typeof val === 'object') {
      try {
          window.sessionStorage[key] = JSON.stringify(val);
      }
      catch(e) {
          window.sessionStorage[key] = "";
      }
    } else {
      window.sessionStorage[key] = val;
    }
  },
  getStr(key) {
    return window.sessionStorage[key] || '';
  },
  getJSONObj(key) {
    if (!window.sessionStorage[key]) return null;
    try {
        return JSON.parse(window.sessionStorage[key]);
    }
    catch(e){
      return {};
    }
  },
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/storage.js